import global from '@/assets/js/global'
import axios from 'axios'

const path = 'backStageLogin2'

/*
 *  INFO
 */

const get = async (token) => {
  const options = {
    headers: { authorization: token },
  }
  const res = await axios.get(`${global.server}${path}`, options)

  return res.data
}

export default {
  get,
}
